
import { Question } from 'altru-types';
import secondsToReadableTime from '@/utils/secondsToReadableTime';
import { useStore } from 'vuex';
import { computed, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ReadMoreText from '@/components/ReadMoreText.vue';

export default {
  name: 'QuestionInfo',
  components: { ReadMoreText },
  setup(): { questionInfo: Ref<Question>; readableMaxDuration: Ref<string>; t: (key: string) => string } {
    const { t } = useI18n();
    const store = useStore();

    const questionInfo: Ref<Question> = computed(() => store.getters['questions/questionInfo']);
    const readableMaxDuration: Ref<string> = computed(() =>
      questionInfo.value.max_duration ? secondsToReadableTime(questionInfo.value.max_duration) : '-',
    );

    return { questionInfo, readableMaxDuration, t };
  },
};
